module.exports = __webpack_public_path__ + "static/media/egratacos3.9554844f.jpg";